const styles = {
  container: 'w-full h-full',

  figure:
    'relative h-full w-full bg-gray-100 rounded-sm overflow-hidden group cursor-pointer',
  image: 'object-cover group-hover:scale-105 duration-200',
};

export default styles;
